import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMainContext } from "../../../Context";
import { login, register, verfiyCode } from "../../../Utils/Apis";

export const useCheck = () => {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const { post } = useMainContext();
  const navigate = useNavigate();

  const check = async () => {
    console.log("s");
    setLoading(true);
    const { data, status } = await post(login, form, true);
    if (+status == 200 && data?.user == "true") {
      navigate("/verifycode", { state: { mobile: form.mobile } });
    } else if (data?.user == "false") {
      navigate("/signup", { state: { mobile: form.mobile } });
    }
    setLoading(false);
  };
  return {
    form,
    setForm,
    loading,
    check,
  };
};
export const useSignUp = () => {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const { post } = useMainContext();
  const { state } = useLocation();
  const navigate = useNavigate();
  // console.log("d", state);
  const mobile = state.mobile || "";

  const signUp = async () => {
    setLoading(true);
    const { data, status } = await post(register, { ...form, mobile }, true);
    if (+status == 200 && data?.user == "true") {
      navigate("/verifycode", { state: { mobile } });
    }
    setLoading(false);
  };
  return {
    form,
    setForm,
    loading,
    signUp,
    mobile,
  };
};
export const useVerfiyCode = () => {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const { post, dispatch } = useMainContext();
  const { state } = useLocation();
  const mobile = state.mobile || "";
  const navigate = useNavigate();

  const sendCode = async () => {
    setLoading(true);
    const { data, status } = await post(verfiyCode, { mobile, ...form }, true);
    if (+status === 200 && data?.user) {
      dispatch("user", data);
      navigate("/dashboard");
    }
    setLoading(false);
  };
  return {
    form,
    setForm,
    loading,
    sendCode,
    mobile,
    navigate,
  };
};
